import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * Component that handles redirect from /select-store to appropriate destination
 * Checks if user needs onboarding before redirecting to stores
 */
export default function SelectStoreRedirect() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    // Check if user needs onboarding before redirecting to stores
    const needsOnboarding = Number(user?.skip) === 0;
    const hasInvitationToken = localStorage.getItem('invitation_token') || 
                              sessionStorage.getItem('invitation_token') ||
                              window.location.search.includes('invite');
    
    if (needsOnboarding && !hasInvitationToken) {
      console.log('SelectStoreRedirect: User needs onboarding, redirecting to /on-boarding');
      navigate('/on-boarding');
    } else {
      console.log('SelectStoreRedirect: Redirecting to stores');
      navigate('/stores');
    }
  }, [navigate, user]);

  // Return null while redirecting
  return null;
}
